import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import '../pages.css';

export const PageHero = ({ id, kicker, title, accent, lede, image, alt, caption, primary, secondary }) => (
  <section className="hw-hero" data-testid={`${id}-hero`}>
    <div className="reference-wrap hw-hero-grid" style={image ? undefined : { gridTemplateColumns: '1fr', paddingBlock: '56px' }}>
      <div className="hw-reveal">
        <p className="hw-kicker">{kicker}</p>
        <h1 className="hw-display">{title} {accent && <em>{accent}</em>}</h1>
        <p className="hw-hero-lede">{lede}</p>
        <div className="mt-8 flex flex-wrap gap-3">
          {primary && <Link to={primary.to} className="reference-button gold" data-testid={`${id}-hero-primary`}>{primary.label} <ArrowRight size={17} /></Link>}
          {secondary && <Link to={secondary.to} className="reference-button outline" data-testid={`${id}-hero-secondary`}>{secondary.label}</Link>}
        </div>
      </div>
      {image && <figure className="hw-reveal" style={{ animationDelay: '.15s' }}><img src={image} alt={alt} width="1264" height="948" />{caption && <figcaption data-testid={`${id}-image-caption`}>{caption}</figcaption>}</figure>}
    </div>
  </section>
);

export const SectionTitle = ({ kicker, title, dark = false }) => (
  <div>
    <p className={`text-xs font-bold tracking-[0.2em] ${dark ? 'text-[#F7C52B]' : 'text-[#795300]'}`}>{kicker}</p>
    <h2 className="hw-display mt-3">{title}</h2>
    <div className="hw-rule" />
  </div>
);

export const CtaBand = ({ id, title, text, to, label }) => (
  <section className="hw-section dark" data-testid={`${id}-cta`}>
    <div className="reference-wrap flex flex-col items-start justify-between gap-6 md:flex-row md:items-center">
      <div><h2 className="hw-display">{title}</h2><p className="mt-3 max-w-xl text-sm text-neutral-400">{text}</p></div>
      <Link to={to} className="reference-button gold" data-testid={`${id}-cta-btn`}>{label} <ArrowRight size={17} /></Link>
    </div>
  </section>
);
